import { httpGet, httpPost, httpPut, httpDelete } from "./AbstractService";
import { paddy } from "./StringService";
import ENDPOINTS from "../data/endpoints.json";
import dayjs from "dayjs";

import SCHOOLS_US_EAST_1 from "../data/schools-us-east-1.json";
import SCHOOLS_US_WEST_2 from "../data/schools-us-west-2.json";

export const ACTIVITY_NAME_FIELDS = [
  {
    label: "Teacher Last Name",
    value: "{teacherLastName}",
    exampleText: "Regulski",
  },
  {
    label: "Teacher First Name",
    value: "{teacherFirstName}",
    exampleText: "Tim",
  },
  {
    label: "Activity Name",
    value: "{activityName}",
    exampleText: "Algebra Coach Class",
  },
  { label: "Location", value: "{locationName}", exampleText: "Room 1701" },
  {
    label: "Remaining Seats",
    value: "{remainingSeats}",
    exampleText: " (42 Seats Left)",
  },
  { label: "hyphen", value: "{hyphen1}", exampleText: " - " },
  { label: "hyphen", value: "{hyphen2}", exampleText: " - " },
  { label: "hyphen", value: "{hyphen3}", exampleText: " - " },
  { label: "colon", value: "{colon1}", exampleText: " : " },
  { label: "colon", value: "{colon2}", exampleText: " : " },
  { label: "colon", value: "{colon3}", exampleText: " : " },
  { label: "comma", value: "{comma1}", exampleText: ", " },
  { label: "comma", value: "{comma2}", exampleText: ", " },
  { label: "comma", value: "{comma3}", exampleText: ", " },
];

export const getAllSchools = () => {
  let schools = SCHOOLS_US_EAST_1.concat(SCHOOLS_US_WEST_2);
  return schools;
};

export const getFirstSchool = () => {
  const allSchools = getAllSchools();
  return allSchools[0];
};

export const getSchoolTeachers = (school, jwt, deptEid = null) => {
  let url = `${ENDPOINTS[school.region].school}/school/teacher`;

  if (deptEid != null) {
    url += `?deptEid=${deptEid}`;
  }

  return httpGet(jwt, url);
};

export const getSchoolAdmins = (school, jwt) => {
  let url = `${ENDPOINTS[school.region].admin}/admn2/school/admin`;
  return httpGet(jwt, url);
};

export const getSchoolGuardians = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].school}/school/guardian`);
};

export const getSchoolTags = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].activity}/tag`);
};

export const getLocations = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].school}/school/location`);
};

export const getSchoolStatus = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].school}/school/status`);
};

export const getPeriodTime = (school, index, isStartTime = true) => {
  let name = "";
  const periodLabel = school.periodLabels[index];
  if (isStartTime === true) {
    if (periodLabel.startHour !== 0) {
      name += `${paddy(periodLabel.startHour, 2, "0")}:${paddy(
        periodLabel.startMinute,
        2,
        "0"
      )}`;
    }
  } else {
    if (periodLabel.endHour !== 0) {
      name += `${paddy(periodLabel.endHour, 2, "0")}:${paddy(
        periodLabel.endMinute,
        2,
        "0"
      )}`;
    }
  }

  return name;
};

// 0-based index
export const getPeriodName = (
  school,
  index,
  showTime = false,
  isStartTime = false
) => {
  let name = "";
  const periodLabel = school.periodLabels[index];
  if (school == null || index == null || isNaN(index)) {
    name = "Activity " + (index + 1);
  } else {
    name = periodLabel.name;
  }

  if (showTime === true) {
    if (isStartTime === true) {
      if (periodLabel.startHour !== 0) {
        name += ` @ ${paddy(periodLabel.startHour, 2, "0")}:${paddy(
          periodLabel.startMinute,
          2,
          "0"
        )}`;
      }
    } else {
      if (periodLabel.endHour !== 0) {
        name += ` @ ${paddy(periodLabel.endHour, 2, "0")}:${paddy(
          periodLabel.endMinute,
          2,
          "0"
        )}`;
      }
    }
  }

  return name;
};

export const getPeriodDetails = (school, index) => {
  if (school == null || index == null || isNaN(index)) {
    return null;
  }
  return school.periodLabels[index];
};

export const getPeriodSingleName = (school, index) => {
  if (school == null || index == null || isNaN(index)) {
    return index + 1;
  }
  return school.periodLabels[index].singleName;
};

export const getSchoolByEid = (eid) => {
  const allSchools = getAllSchools();
  for (const school of allSchools) {
    if (school.eid === eid) {
      return school;
    }
  }
  return null;
};

export const getSchoolBySubdomain = (subdomain) => {
  const allSchools = getAllSchools();
  for (const school of allSchools) {
    if (school.subdomain === subdomain) {
      return school;
    }
  }
  return null;
};

export const getHomeroomPeriods = (school, jwt) => {
  let url = `${ENDPOINTS[school.region].school}/homeroom/period`;
  return httpGet(jwt, url);
};

export const adminSaveHomeroomPeriod = (school, jwt, name) => {
  let url = `${ENDPOINTS[school.region].school}/homeroom/period`;
  return httpPost(jwt, url, { name });
};

export const getHomeroomProctors = (school, jwt) => {
  let url = `${ENDPOINTS[school.region].school}/homeroom/proctor`;
  return httpGet(jwt, url);
};

export const adminSaveHomeroomProctor = (
  school,
  jwt,
  proctorEid,
  homeroomPeriodEid,
  locationEid
) => {
  let url = `${ENDPOINTS[school.region].school}/homeroom/proctor`;
  return httpPost(jwt, url, {
    proctorEid,
    homeroomPeriodEid,
    locationEid,
  });
};

export const adminSaveHomeroomProctors = (
  school,
  jwt,
  homeroomPeriodEid,
  entries
) => {
  let url = `${ENDPOINTS[school.region].school}/homeroom/proctor`;
  return httpPut(jwt, url, {
    homeroomPeriodEid,
    entries,
  });
};

export const adminUpdateHomeroomLocation = (
  school,
  jwt,
  homeroomPeriodEid,
  locationEid
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/homeroom/proctor/${homeroomPeriodEid}`;
  return httpPut(jwt, url, {
    locationEid,
  });
};

export const adminSaveStudentHomeroom = (
  school,
  jwt,
  homeroomTeacherId,
  homeroomLocation,
  studentEid
) => {
  let url = `${ENDPOINTS[school.region].school}/homeroom/student`;
  return httpPost(jwt, url, {
    homeroomTeacherId,
    studentEid,
    homeroomLocation,
  });
};

export const adminDeleteStudentHomeroom = (school, jwt, id) => {
  let url = `${ENDPOINTS[school.region].school}/homeroom/student/${id}`;
  return httpDelete(jwt, url);
};

export const adminSaveStudentHomerooms = (
  school,
  jwt,
  homeroomPeriodEid,
  entries
) => {
  let url = `${ENDPOINTS[school.region].school}/homeroom/student`;
  return httpPut(jwt, url, {
    homeroomPeriodEid,
    entries,
  });
};

export const getSchoolGrades = (school, jwt) => {
  let url = `${ENDPOINTS[school.region].school}/school/grade`;
  return httpGet(jwt, url);
};

export const getSchoolDates = (school, jwt, dateStart, dateEnd) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/school/date?dateStart=${dateStart}&dateEnd=${dateEnd}`;
  return httpGet(jwt, url);
};

export const getGraduatingYear = () => {
  const today = dayjs();

  let year = 0;
  if (today.month() >= 7) {
    year = parseInt(today.format("YYYY")) + 1;
  } else {
    year = parseInt(today.format("YYYY"));
  }

  return year;
};

export const isScoreEnabled = (school) =>
  school != null && school.scoreEnabled === "Y";
export const isActivitiesEnabled = (school) =>
  school != null && school.activitiesEnabled === "Y";
export const isCheckinEnabled = (school) =>
  school != null && school.checkinEnabled === "Y";
export const isCourseEnabled = (school) =>
  school != null && school.courseEnabled === "Y";
export const isMeetingEnabled = (school) =>
  school != null && school.meetingEnabled === "Y";
export const isEventEnabled = (school) =>
  school != null && school.eventEnabled === "Y";
export const isPassEnabled = (school) =>
  school != null && school.passEnabled === "Y";
export const isCommunityServiceEnabled = (school) =>
  school != null && school.communityServiceEnabled === "Y";

export const getEmptySchool = () => {
  return {
    passThroughEnabled: "N",
    region: "us-east-1",
  };
};

export const getSchoolSchedules = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].school}/school/schedule`);
};

export const addSchoolSchedule = (
  school,
  jwt,
  name,
  description,
  startTime,
  endTime
) => {
  return httpPost(jwt, `${ENDPOINTS[school.region].school}/school/schedule`, {
    name,
    description,
    startTime,
    endTime,
  });
};

export const getScheduleDetails = (school, jwt, eid) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].school}/school/schedule/${eid}`
  );
};
